import { TDropdownItem, TLiftedFormModel, TLiftedInputTypes, TUpdateFields } from './form.model';

export const FORM_UTILS = {
  /**
   * Update Input by Event generated from html
   * @param $event from html tag
   * @param existingInput existing input
   * @returns return TLiftedFormModel<T>['inputs'][number]
   */
  updateInputByEvent: <T>(
    $event: Event,
    existingInput: TLiftedFormModel<T>['inputs'][number],
    isOtherOptionValue = false,
  ) => {
    let value: string | undefined = ($event.target as HTMLInputElement)?.value;

    let updatedInput = {
      ...existingInput,
    };

    switch (updatedInput.input.type) {
      case 'INPUT':
        if (value === '') value = undefined;
        updatedInput = {
          ...updatedInput,
          input: {
            ...updatedInput.input,
            value:
              updatedInput.input.subType === 'number' && value !== undefined && value !== '' ? Number(value) : value,
          },
        };
        break;
      case 'DROPDOWN':
      case 'DROPDOWN_WITH_SEARCH':
        if (updatedInput.input.inputValueForOtherOption && isOtherOptionValue) {
          updatedInput = {
            ...updatedInput,
            input: {
              ...updatedInput.input,
              inputValueForOtherOption: {
                ...updatedInput.input.inputValueForOtherOption,
                input: {
                  ...updatedInput.input.inputValueForOtherOption.input,
                  value: value,
                },
              },
            },
          };
        } else {
          updatedInput = {
            ...updatedInput,
            input: {
              ...updatedInput.input,
              value: updatedInput.input.subType === 'number' ? (value ? Number(value) : undefined) : value,
              ...(updatedInput.input.inputValueForOtherOption && {
                inputValueForOtherOption: undefined,
              }),
            },
          };
        }
        break;
      case 'TEXTAREA':
        updatedInput = {
          ...updatedInput,
          input: {
            ...updatedInput.input,
            value: value,
          },
        };
        break;
      case 'SEARCH':
        updatedInput = {
          ...updatedInput,
          input: {
            ...updatedInput.input,
            searchText: value,
            //When suggestion is selected, we set the updatedInput's value to the searchText. Now if user starts editing the
            //searchfield, searchtext would differ from updatedInput's value and hence suggestionSelected would be set to false.
            suggestionSelected: !!value && value === updatedInput.input.value,
            value: !!value && value === updatedInput.input.value ? value : undefined,
            //Whenever ionChange event is invoked on searchbar, we should remove the error message: "No results found"
            searchResultsNotFound: undefined,
          },
        };
        break;
      case 'CHECKBOX': {
        updatedInput = {
          ...updatedInput,
          input: {
            ...updatedInput.input,
            checked: ($event.target as HTMLInputElement).checked,
          },
        };
        break;
      }
    }
    return updatedInput;
  },

  updateInputBySelectedList: <T>(
    selectedList: TDropdownItem['value'][],
    existingInput: TLiftedFormModel<T>['inputs'][number],
  ) => {
    let updatedInput = {
      ...existingInput,
    };
    switch (updatedInput.input.type) {
      case 'DROPDOWN_WITH_SEARCH':
        updatedInput = {
          ...updatedInput,
          input: {
            ...updatedInput.input,
            value: selectedList,
          },
        };
        break;
    }
    return updatedInput;
  },

  getUpdatedDropdownValue: <T>(existingInput: TLiftedInputTypes<T>, updatedValues: TUpdateFields['updatedValues']) => {
    if (
      (updatedValues?.type === 'DROPDOWN' && existingInput.input.type === 'DROPDOWN') ||
      (updatedValues?.type === 'DROPDOWN_WITH_SEARCH' && existingInput.input.type === 'DROPDOWN_WITH_SEARCH')
    ) {
      let updatedInputValue: string | number | (string | number)[] | undefined = undefined;
      const existingInputValue = existingInput.input.value;

      if (updatedValues.value) {
        updatedInputValue = updatedValues.value;
      } else if (typeof existingInputValue === 'string' || typeof existingInputValue === 'number') {
        updatedInputValue = updatedValues.options?.some((opt) => opt.value === existingInputValue)
          ? existingInput.input.value
          : undefined;
      } else {
        updatedInputValue = existingInputValue?.filter((val) =>
          updatedValues.options?.some((opt) => opt.value === val),
        );
      }
      return updatedInputValue;
    } else return undefined;
  },
};
